<ng-container>
    <div class="mx-4 my-4 indication-quote-step-container">
        @if(indicationQuoteDetails()){
            <p class="bg-secondary px-4 py-3 rounded">{{quoteFeedbackMessage()}}</p>
        }
        <app-request-quote-referral-step></app-request-quote-referral-step>
    </div>
    <mat-action-row class="accordion-footer d-flex align-items-stretch justify-content-between py-5 px-6">
        <div class="d-flex align-items-center me-3" [attr.title]="this.indicationReferredDeclinedLock() ? 'Accept Declinature and Exit' : ''">
            <img src="assets\icon-assets\png\save-exit-icon.png" alt="Save and Exit" (click)="onSaveIndicationHomeAction()" class="h-40px w-40px cursor-pointer bg-white border border-1 border-secondary p-2 rounded" draggable="false" />
        </div>
        <div class="d-flex">
            @if(this.authService.isPolicyType()){
                <button mat-button type="button" (click)="OnRequestQuote()" class="btn btn-lg btn-primary continue-btn">Request Quote</button>
            }@else {
                @if(isBroker()){
                    @if(this.isIndicationType()){
                        <div [attr.title]="this.maxAmendLimit() ? 'Maximum amendments reached - Please message and submit referral' : null">
                            <button mat-button type="button" (click)="onBrokerAmendIndication()" [disabled]="this.quoteAmendLock() || !this.isIndicationType() || this.isReferralLock() || this.maxAmendLimit()" class="btn btn-lg btn-light-primary me-3 back-btn" >Amend</button>
                        </div>
                    }
                        <button mat-button type="button" (click)="submitReferral()"class="btn btn-lg btn-light-primary me-3 back-btn" [disabled] = "this.isReferralLock()">Submit Referral</button>
                        <button mat-button type="button" [disabled]="this.isIndicationReferralLock() || this.indicationReferredDeclinedLock() || this.isReferralLock() || this.maxAmendLock()" (click)="referralClearance()" class="btn btn-lg btn-primary continue-btn">Request Quote</button>
                }
                @if(isUwAdmin()) {
                    <button type="button" class="btn btn-lg btn-light-primary me-3 back-btn" id="indication-next-1" (click)="onUWAdminAmendIndication()">Amend </button>
                    @if (!isIndicationAmendByUWAdmin()) {
                        <button type="button" class="btn btn-lg btn-light-primary continue-btn me-3" id="indication-next-1" (click)="onDeclineIndication()">Decline</button>
                        <button type="button" class="btn btn-lg btn-primary me-3 back-btn" id="indication-next-1" (click)="onApproveIndication()">Approve </button>
                    }@else {
                        <button type="button" class="btn btn-lg btn-primary continue-btn" id="indication-next-1" (click)="onSubmitIndication()">Approve</button>
                    }
                }
            }
        </div>                                                        
    </mat-action-row>
</ng-container>
